import { Briefcase, ClipboardCheck, LayoutDashboard, Package, Percent, Scale } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type Pillar = { Icon: LucideIcon; title: string; body: string };

const PILLARS: ReadonlyArray<Pillar> = [
  {
    Icon: Package,
    title: 'Ingrédients & coût/unité',
    body: 'Unité d\'achat, unité de recette, facteur de conversion, prix d\'achat. Velko calcule le coût exact par millilitre ou par gramme.',
  },
  {
    Icon: Percent,
    title: 'Recettes & pour cost %',
    body: 'Lie un produit à sa recette décimale. Coût, marge et pour cost % en temps réel. Versionnage : une seule recette active par produit.',
  },
  {
    Icon: ClipboardCheck,
    title: 'Inventaire à l\'aveugle',
    body: 'Le blind count : ton équipe compte sans voir le théorique. Données fiables, anti-biais — sur le POS, même hors ligne.',
  },
  {
    Icon: Scale,
    title: 'Rapport d\'écart',
    body: 'Théorique vs réel sur la période : écart en volume, en %, et valorisé en F CFA. Alerte surdosage au-delà du seuil.',
  },
  {
    Icon: LayoutDashboard,
    title: 'Dashboard gérant',
    body: 'Chiffre d\'affaires, valeur d\'écart totale, pour cost moyen, top ingrédients qui fuient. La photo complète du contrôle.',
  },
  {
    Icon: Briefcase,
    title: 'Dashboard investisseur',
    body: 'Une vue allégée : revenu et stock valorisé, sans le détail opérationnel. Transparence pour tes associés, sans tout exposer.',
  },
];

export default function BarPillarsV2() {
  return (
    <section className="bg-charcoal-800 py-20 text-white md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel tone="dark">Ce qu'il y a dans la boîte</SectionLabel>
        <h2 className="mt-3 max-w-3xl font-marketing-display text-[clamp(30px,4.2vw,56px)] font-bold leading-[1.02] tracking-[-0.035em] text-white">
          Six outils. <span className="text-lime-500">Un seul objectif.</span>
        </h2>
        <p className="mt-4 max-w-xl font-marketing-body text-[17px] leading-[1.55] text-charcoal-200">
          Tout est déjà dans Velko, prêt à activer. Pas un module à part qu'il faut relier — c'est ta
          caisse qui devient intelligente.
        </p>

        <div className="mt-12 grid gap-[2px] border-2 border-charcoal-700 bg-charcoal-700 sm:grid-cols-2 lg:grid-cols-3">
          {PILLARS.map(({ Icon, title, body }) => (
            <div
              key={title}
              className="flex min-h-[210px] flex-col gap-4 bg-charcoal-800 px-7 py-8 transition-colors duration-150 hover:bg-charcoal-900"
            >
              <span className="flex h-12 w-12 items-center justify-center border-2 border-lime-500 bg-charcoal-900 text-lime-500">
                <Icon className="h-[22px] w-[22px]" strokeWidth={2} aria-hidden="true" />
              </span>
              <h3 className="font-marketing-display text-[20px] font-bold leading-[1.15] tracking-[-0.01em] text-white">
                {title}
              </h3>
              <p className="font-marketing-body text-[14px] leading-[1.55] text-charcoal-200">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
